import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "remove-modal-title",
  "aria-label": "Remove Item Modal Title"
};
const _hoisted_2 = {
  class: "remove-modal-text",
  "aria-label": "Remove Item Modal Text"
};
const _hoisted_3 = {
  key: 0,
  class: "remove-modal-part-info",
  "aria-label": "Remove Item Modal Part Name"
};
const _hoisted_4 = {
  class: "remove-modal-part-description"
};
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "part-info-dash"
}, " - ", -1);
const _hoisted_6 = {
  class: "remove-modal-part-number"
};
const _hoisted_7 = {
  key: 1,
  class: "remove-modal-materials",
  "aria-label": "Remove Modal Material List"
};
const _hoisted_8 = {
  class: "remove-modal-part-description"
};
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", {
  class: "part-info-dash"
}, " - ", -1);
const _hoisted_10 = {
  class: "remove-modal-part-number"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_DcModal = _resolveComponent("DcModal");
  return _openBlock(), _createBlock(_component_DcModal, {
    onModalClose: _cache[2] || (_cache[2] = $event => $options.closeModal()),
    "aria-label": "Remove Item Modal"
  }, {
    header: _withCtx(() => [_createElementVNode("div", _hoisted_1, _toDisplayString($props.titleMessage), 1), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", null, [_createElementVNode("p", null, _toDisplayString($props.removeMessage), 1)])])]),
    body: _withCtx(() => [!$props.materialList && !$props.removeAllItems ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString($props.partDescription), 1), _hoisted_5, _createElementVNode("div", _hoisted_6, _toDisplayString($props.productNumber), 1)])) : (_openBlock(), _createElementBlock("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.materialList, material => {
      return _openBlock(), _createElementBlock("div", {
        key: material.name,
        class: "remove-modal-part-info",
        "aria-label": "Remove Item Modal Part Name"
      }, [_createElementVNode("div", _hoisted_8, _toDisplayString(material.name), 1), _hoisted_9, _createElementVNode("div", _hoisted_10, _toDisplayString(material.number), 1)]);
    }), 128))]))]),
    footer: _withCtx(() => [_createElementVNode("button", {
      class: "remove-modal-button-no",
      onClick: _cache[0] || (_cache[0] = $event => $options.closeModal()),
      "aria-label": "No Button"
    }, _toDisplayString($options.getI18nMessage('button.no.UPPER')), 1), _createElementVNode("button", {
      class: "remove-modal-button-yes",
      type: "button",
      onClick: _cache[1] || (_cache[1] = _withModifiers($event => $options.removeProduct(), ["prevent"])),
      "aria-label": "Yes Button"
    }, _toDisplayString($options.getI18nMessage('button.yes.UPPER')), 1)]),
    _: 1
  });
}